
import Vue from 'vue';

import moment from 'moment';

export default Vue.filter('hour', (value) => {
    const date = moment(value).toDate();
    return moment(date).locale('es').fromNow();
})
